import {Graphics, InteractionEvent, Sprite, Texture} from 'pixi.js';
import {TextureUrlLoader} from '../../../../../../../../utils/TextureUrlLoader';
import {Pivot} from '../../../../../../../../utils/Pivot';

export class PointsButton extends Sprite
{
    graphicsBg: Graphics;
    icon: Sprite | undefined;

    constructor(private iconPath: string, private  onClick: Function) {
        super();

        this.graphicsBg = new Graphics();
        this.graphicsBg.beginFill(0, .001);
        this.graphicsBg.drawCircle(0, 0, 20);
        this.graphicsBg.endFill();
        this.addChild(this.graphicsBg).interactive = true;
        this.initialize();
        this.graphicsBg.on('pointerdown', this.onPointerDown, this);
    }

    destroy(): void {
        this.graphicsBg.off('pointerdown', this.onPointerDown, this);
        super.destroy({children: true});
    }

    private async initialize(): Promise<void> {
        let increaseTexture: Texture | null = await TextureUrlLoader.load(this.iconPath);
        this.icon = new Sprite(increaseTexture!);
        this.addChild(this.icon).interactive = false;
        Pivot.centerPivot(this.icon);
    }

    private onPointerDown(e: InteractionEvent): void {
        this.onClick();
    }
}
